export default "__VITE_ASSET__B$6BzcBg__"